<script setup lang="ts">
import { isFirefox, isOpera } from 'mobile-device-detect'
import appStore from '@/assets/footer/download_appstore-min.png'
import playStore from '@/assets/footer/download_playstore-min.png'
import { showManager } from '@/components/goat/layout/cookies/Manager'

import {
  canInstallAsApp,
  checkBoxDisableInstallPrompt,
  deferredPrompt,
  disableInstallPrompt,
  showConfirmDisableInstallPrompt,
  showInstallPrompt,
  supportedInstallAsApp
} from '@/components/goat/layout/install/Prompt'
import LogoSite from '/src/assets/logo.svg'

const { t, locale } = useI18n()
const auth = useAuthStore()
const isProd = siteUtils.isProd

function onAdd() {
  checkBoxDisableInstallPrompt.value = false
  showConfirmDisableInstallPrompt.value = false
  disableInstallPrompt.value = false
  localStorage?.setItem?.('dip', '')
  if (canInstallAsApp.value) {
    deferredPrompt.value?.prompt?.()
  } else {
    showInstallPrompt.value = true
  }
}
</script>

<template>
  <div class="bg-main-footer px-4 py-8 big:px-8 big:py-10 tracking-wide mt-5 relative">
    <div class="max-w-(--breakpoint-xl) mx-auto flex flex-wrap">
      <div class="text-white font-semibold w-full">
        {{ t('footer.downloadGames') }}
      </div>
      <div class="mt-5 w-full">
        <a
          href="https://apps.apple.com/developer/gamesture-sp-z-o-o/id1079884679"
          target="_blank"
          rel="nofollow"
        >
          <el-image
            :src="appStore"
            :title="t('footer.appStoreTitle')"
            class="max-w-[45%] big:max-w-[140px]"
          />
        </a>
        <a
          href="https://play.google.com/store/apps/dev?id=6838434049690937885"
          target="_blank"
          rel="nofollow"
        >
          <el-image
            :src="playStore"
            :title="t('footer.playStoreTitle')"
            class="ml-4 max-w-[45%] big:max-w-[140px]"
          />
        </a>
      </div>
      <hr class="border border-white mt-5 w-full">
      <ul class="text-white list-none w-full mt-2 mb-5">
        <li class="big:inline-block pt-4">
          <a
            :href="`https://gamesture.com/terms-of-service?flang=${locale}`"
            class="pr-2 sm:pr-5"
            rel="nofollow"
            target="_blank"
          >
            {{ t('footer.termsOfService') }}
          </a>
        </li>
        <li class="big:inline-block pt-4">
          <a
            :href="`https://gamesture.com/privacy-policy?flang=${locale}`"
            class="pr-2 sm:pr-5"
            rel="nofollow"
            target="_blank"
          >
            {{ t('footer.privacyPolicy') }}
          </a>
        </li>
        <li class="big:inline-block pt-4">
          <a
            class="pr-2 sm:pr-5 cursor-pointer"
            rel="nofollow"
            @click.prevent.stop="showManager = true"
          >{{ t('footer.manageCookies') }}</a>
        </li>
        <li
          v-if="!isProd"
          class="big:inline-block pt-4"
        >
          <router-link
            to="/admin/add-game"
            class="pr-2 sm:pr-5 text-[#5c727a] hover:text-white transition-colors"
          >
            Game settings (GOAT)
          </router-link>
        </li>
      </ul>
      <div class="w-1/2 text-[#5c727a] py-5">
        Gamesture sp. z o.o.
      </div>
      <div class="w-1/2 text-right py-5">
        <a
          href="https://gamesture.com/"
          target="_blank"
          rel="noreferrer"
        >
          <LogoSite class="text-white max-w-[80px] inline-block" />
        </a>
      </div>
      <div
        v-if="auth.isLogged"
        class="absolute bottom-4 flex items-center gap-x-2"
      >
        <template
          v-if="!supportedInstallAsApp || (supportedInstallAsApp && !isOpera && !isFirefox && canInstallAsApp)"
        >
          <el-tooltip
            effect="dark"
            :content="t('footer.addToHomeScreen')"
          >
            <icon-ify
              icon="ic:round-install-mobile"
              class="inline text-xl text-[#5c727a] hover:text-white cursor-pointer"
              @click="onAdd"
            />
          </el-tooltip>
        </template>
      </div>
    </div>
  </div>
</template>

<style scoped></style>
